module.exports = __webpack_public_path__ + "img/car-16.a0861278.jpg";